module.exports = __webpack_public_path__ + "img/pestanas-3.065d432d.svg";